module.exports = __webpack_public_path__ + "static/musicianDrones-64fe2d1c45746b259565301ac0384663.png";